import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-FormMigrateCollections',
	containerWide: 'c-FormMigrateCollections--Wide',
	stepperWrap: 'c-FormMigrateCollections__StepperWrap',
	content: 'c-FormMigrateCollections__Content',
	mapFieldsHeading: 'c-FormMigrateCollections__MapFieldsHeading',
	mapFieldsBreadcrumb: 'c-FormMigrateCollections__MapFieldsBreadcrumb',
	mapFieldsCount: 'c-FormMigrateCollections__MapFieldsCount',
	footerRow: 'c-FormMigrateCollections__FooterRow',
	footerNote: 'c-FormMigrateCollections__FooterNote',
	footerFieldsLost: 'c-FormMigrateCollections__FooterFieldsLost',
	footerFieldsLostIcon: 'c-FormMigrateCollections__FooterFieldsLostIcon',
	intro: 'c-FormMigrateCollections__Intro',
	warning: 'c-FormMigrateCollections__Warning',
	warningLabel: 'c-FormMigrateCollections__WarningLabel',
	list: 'c-FormMigrateCollections__List',
	meta: 'c-FormMigrateCollections__Meta',
	metaBold: 'c-FormMigrateCollections__Meta__Bold',
	metaMuted: 'c-FormMigrateCollections__Meta__Muted',
	label: 'c-FormMigrateCollections__Label',
	selectWrapper: 'c-FormMigrateCollections__SelectWrapper',
	select: 'c-FormMigrateCollections__Select',
	selectChevron: 'c-FormMigrateCollections__SelectChevron',
};

export const Style = {
	[CSS.container]: {
		width: '560px',
	},
	[CSS.containerWide]: {
		width: '820px',
	},
	[CSS.stepperWrap]: {
		'padding-bottom': DefaultTheme.space(5),
	},
	[CSS.content]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.mapFieldsHeading]: {
		'font-size': '1.3rem',
		'font-weight': 700,
		'padding-bottom': DefaultTheme.space(2),
	},
	[CSS.mapFieldsBreadcrumb]: {
		'padding-bottom': DefaultTheme.space(1),
	},
	[CSS.mapFieldsCount]: {
		'padding-bottom': DefaultTheme.space(2),
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.footerRow]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		gap: DefaultTheme.space(3),
		'padding-top': DefaultTheme.space(3),
	},
	[CSS.footerNote]: {
		color: DefaultTheme.font.color.supporting,
		'font-size': '0.85rem',
	},
	[CSS.footerFieldsLost]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(1),
		'flex-shrink': 0,
		color: DefaultTheme.font.color.error,
		'font-weight': 700,
		'font-size': '0.85rem',
	},
	[CSS.footerFieldsLostIcon]: {
		'font-size': '18px',
		'flex-shrink': 0,
	},
	[CSS.intro]: {
		'padding-bottom': DefaultTheme.space(4),
		'line-height': 1.5,
	},
	[CSS.warning]: {
		color: DefaultTheme.font.color.error,
		'padding-bottom': DefaultTheme.space(4),
		'line-height': 1.5,
	},
	[CSS.warningLabel]: {
		'font-weight': 700,
	},
	[CSS.list]: {
		'padding-left': DefaultTheme.space(5),
		margin: 0,
		'padding-bottom': DefaultTheme.space(4),
		'line-height': 1.5,
		'& li': {
			'padding-bottom': DefaultTheme.space(1),
		},
	},
	[CSS.meta]: {
		'padding-bottom': DefaultTheme.space(4),
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.metaBold]: {
		color: DefaultTheme.font.color.primary,
		'font-weight': 700,
	},
	[CSS.metaMuted]: {
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.label]: {
		display: 'block',
		'padding-bottom': DefaultTheme.space(2),
		'font-size': '0.75rem',
		'font-weight': 700,
		'letter-spacing': '0.04em',
		'text-transform': 'uppercase',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.selectWrapper]: {
		position: 'relative',
	},
	[CSS.select]: {
		width: '100%',
		appearance: 'none',
		'-webkit-appearance': 'none',
		'-moz-appearance': 'none',
		background: 'transparent',
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '4px',
		padding: `${DefaultTheme.space(3)} ${DefaultTheme.space(9)} ${DefaultTheme.space(3)} ${DefaultTheme.space(3)}`,
		'font-size': DefaultTheme.font.size + 'px',
		color: DefaultTheme.font.color.primary,
	},
	[CSS.selectChevron]: {
		position: 'absolute',
		top: '50%',
		right: DefaultTheme.space(3),
		transform: 'translateY(-50%)',
		'pointer-events': 'none',
		color: DefaultTheme.font.color.supporting,
	},
};
